import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Loader2, ArrowRight } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;
const T = {
  it: { name: 'Nome e cognome', email: 'Email', password: 'Password (min. 8 caratteri)', course: 'Corso di laurea', uni: 'Ateneo',
    privacy: 'Ho letto la', privacyLink: 'Privacy Policy', submit: 'Registrati e accedi', have: 'Hai già un account?', login: 'Accedi',
    note: 'Con questo account accedi alle lectures e alle risorse Vocal Fitness indicate nella lecture.', err: 'Registrazione non riuscita' },
  en: { name: 'Full name', email: 'Email', password: 'Password (min. 8 characters)', course: 'Degree course', uni: 'University',
    privacy: 'I have read the', privacyLink: 'Privacy Policy', submit: 'Sign up and enter', have: 'Already have an account?', login: 'Log in',
    note: 'This account gives you access to the lectures and to the Vocal Fitness resources listed in the lecture.', err: 'Sign-up failed' },
};
const detail = (d, fb) => (typeof d === 'string' ? d : Array.isArray(d) ? d.map((e) => e?.msg).filter(Boolean).join(' · ') : fb);

export const LectureSignupForm = ({ slug, lang = 'it', dark = false, onDone }) => {
  const t = T[lang] || T.it;
  const { setAuth } = useAuth();
  const navigate = useNavigate();
  const [f, setF] = useState({ full_name: '', email: '', password: '', degree_course: '', university: '' });
  const [ok, setOk] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.value }));
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr('');
    try {
      const r = await axios.post(`${API}/api/lectures/${slug}/register`, { ...f, language: lang });
      setAuth(r.data.access_token, r.data.user);
      onDone?.();
      navigate(`/${slug}`);
      window.scrollTo(0, 0);
    } catch (ex) { setErr(detail(ex.response?.data?.detail, t.err)); } finally { setBusy(false); }
  };
  const input = `w-full rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${dark ? 'bg-white/10 border border-white/20 text-white placeholder:text-blue-100/50' : 'bg-white border border-slate-300 text-slate-900'}`;
  return (
    <form onSubmit={submit} className="space-y-3" data-testid="lecture-signup-form">
      <input required value={f.full_name} onChange={set('full_name')} placeholder={t.name} className={input} data-testid="signup-name" autoComplete="name" />
      <input required type="email" value={f.email} onChange={set('email')} placeholder={t.email} className={input} data-testid="signup-email" autoComplete="email" />
      <input required type="password" minLength={8} value={f.password} onChange={set('password')} placeholder={t.password} className={input} data-testid="signup-password" autoComplete="new-password" />
      <div className="grid sm:grid-cols-2 gap-3">
        <input required value={f.degree_course} onChange={set('degree_course')} placeholder={t.course} className={input} data-testid="signup-course" />
        <input required value={f.university} onChange={set('university')} placeholder={t.uni} className={input} data-testid="signup-university" />
      </div>
      <label className={`flex items-start gap-2 text-xs ${dark ? 'text-blue-100/80' : 'text-slate-600'}`}>
        <input required type="checkbox" checked={ok} onChange={(e) => setOk(e.target.checked)} className="mt-0.5" data-testid="signup-privacy" />
        <span>{t.privacy} <Link to="/privacy" target="_blank" className="underline">{t.privacyLink}</Link></span>
      </label>
      {err && <p className="text-sm text-rose-500" data-testid="signup-error">{err}</p>}
      <button disabled={busy || !ok} className="w-full flex items-center justify-center gap-2 py-3 rounded-xl bg-gradient-to-r from-blue-600 to-blue-700 text-white font-bold shadow-lg shadow-blue-500/25 disabled:opacity-50" data-testid="signup-submit">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <ArrowRight className="w-4 h-4" />} {t.submit}
      </button>
      <p className={`text-xs ${dark ? 'text-blue-100/60' : 'text-slate-500'}`}>{t.note}</p>
      <p className={`text-sm ${dark ? 'text-blue-100/80' : 'text-slate-600'}`}>{t.have} <Link to={`/login?next=/${slug}`} onClick={onDone} className="font-semibold underline" data-testid="signup-login-link">{t.login}</Link></p>
    </form>
  );
};
